module.exports = __webpack_public_path__ + "static/media/bg-inicio-front.cb191bc1.png";